exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".suggestion[data-v-b2eaaece]{cursor:pointer}.suggestion[data-v-b2eaaece]:hover{--default-font-color:#4466f2}", ""]);

// exports
